import axios from "axios"
import Cognito  from './cognito.js'

// ログインセッションが無効な場合に投げるエラー
class SessionExpiredError extends Error {
    constructor(cause) {
        super('ログインセッションが切れています。再度ログインしてください。')
        this.name = 'SessionExpiredError'
        this.cause = cause
    }
}

// DBアクセス用API
const dbaccessApi = setupInterceptors(
    axios.create({
        baseURL: process.env.VUE_APP_DBACCESS_API_URL,
        timeout: 10000
    })
)

// 管理画面用API
const adminwebApi = setupInterceptors(
    axios.create({
        baseURL: process.env.VUE_APP_ADMINWEB_API_URL,
        timeout: 10000
    })
)

// 顔認証API
const faceDetectApi = setupInterceptors(
    axios.create({
        baseURL: process.env.VUE_APP_FACEDETECT_API_URL,
        timeout: 10000
    })
)

function setupInterceptors(api){
    // リクエスト時に自動でトークン付与
    api.interceptors.request.use(
        async (config) => {
            let auth
            try {
                auth = await Cognito.getCognitoUserAttribute();
            } catch (e) {
                // ログインセッションが無効 → リクエストを送信せずエラーにする
                return Promise.reject(new SessionExpiredError(e))
            }

            config.headers.Authorization = `Bearer ${auth.idToken}`;
            if (auth.licenseeId) {
                config.headers["Prooface-Id"] = `${auth.licenseeId}`;
            }

            return config
        },
        (error) => Promise.reject(error)
    )
    // レスポンス設定
    api.interceptors.response.use(
        (response) => response,
        (error) => {
            return Promise.reject(error)
        }
    )
    return api
}

export {
    dbaccessApi,
    adminwebApi,
    faceDetectApi,
    SessionExpiredError
}